import { types } from './constants';

export const castNotAllowed = () => ({
  type: types.CAST_NOT_ALLOWED
});

export const cleanupPlayer = () => ({
  type: types.CLEAN_UP
});

export const setPlayerInstance = (value) => ({
  type: types.SET_INSTANCE,
  player: value
});

export const setIsCasting = (isCasting) => ({
  type: types.SET_IS_CASTING,
  isCasting
});

export const playbackError = (error, isFormatUnsupported) => ({
  type: types.PLAYBACK_ERROR,
  error,
  isFormatUnsupported,
});

export const updateDuration = (duration) => ({
  type: types.UPDATE_DURATION,
  duration,
});

export const updateFullscreenStatus = (isFullscreen) => ({
  type: types.UPDATE_FULLSCREEN_STATUS,
  isFullscreen,
});

export const setStopNextEpisode = (isStopped) => ({
  type: types.STOP_NEXT_EPISODE,
  isStopped
});

